/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */

import React from 'react';

const SunIcon = () => {
  return (
    <svg
      width='1.75em'
      height='1.75em'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      pointerEvents='none'
    >
      <circle cx='11.9998' cy='11.9998' r='5.75375' fill='currentColor' />
      <g>
        <circle
          cx='3.08982'
          cy='6.85502'
          r='1.71143'
          transform='rotate(-60 3.08982 6.85502)'
          fill='currentColor'
        />
        <circle
          cx='3.0903'
          cy='17.1436'
          r='1.71143'
          transform='rotate(-120 3.0903 17.1436)'
          fill='currentColor'
        />
        <circle cx='12' cy='22.2881' r='1.71143' fill='currentColor' />
        <circle
          cx='20.9101'
          cy='17.1436'
          r='1.71143'
          transform='rotate(-60 20.9101 17.1436)'
          fill='currentColor'
        />
        <circle
          cx='20.9101'
          cy='6.8555'
          r='1.71143'
          transform='rotate(-120 20.9101 6.8555)'
          fill='currentColor'
        />
        <circle cx='12' cy='1.71143' r='1.71143' fill='currentColor' />
      </g>
    </svg>
  );
};

export default SunIcon;
